/* src/app/core/header/header.component.scss */
.absolute-top {
  position: absolute !important;
}
#dropdown01 {
  background-color: transparent;
  border: none;
}
.own-nav,
.own-nav > div {
  height: 60px;
}
.own-nav .left-group,
.own-nav > div .left-group {
  max-width: 80px;
}
.own-nav > div {
  padding: 0;
}
.own-nav .main-link {
  height: 60px;
  line-height: 20px;
  cursor: pointer;
  display: inline-block;
  padding: 18px;
  font-size: 24px;
}
.own-nav .main-link.navbar-brand {
  font-size: 36px;
  padding: 14px;
  margin: 0;
  font-family: "Campton-Bold";
  line-height: 40px;
}
.own-nav .left-group .main-link {
  display: inline-block;
  margin-left: 0;
  text-align: left;
  left: 15px;
  position: absolute;
}
.own-nav .right-group .main-link {
  display: inline-block;
  margin-right: 0;
  text-align: right;
  right: 15px;
  position: absolute;
}
.own-nav .nav-item.dropdown.show button {
  background-color: #ffffff !important;
  fill: #565a6a !important;
}
.dropdown-menu {
  border-radius: 0;
  margin-top: 45px;
  border: none;
  padding: 16px 16px;
  min-width: 332px;
}
.dropdown-menu.super-user-menu {
  border: 1px solid #ccc;
}
.own-nav .right-group .dropdown-menu {
  left: 6px !important;
}
.own-nav .left-group .dropdown-menu {
  left: -6px !important;
}
.dropdown-item {
  font-size: 14px;
  letter-spacing: 5px;
  line-height: 25px;
  font-family: "Campton-Book";
  text-shadow: none;
  color: #555969 !important;
  text-transform: uppercase;
  padding: 18px 56px;
  cursor: pointer;
}
.legal {
  color: #adb1b9 !important;
}
.dropdown-item.active,
.dropdown-item:active,
.dropdown-item:hover {
  background-color: #6dcc09 !important;
  color: #ffffff !important;
  cursor: pointer;
  font-family: "Campton-Bold";
}
.own-nav.super-user-header {
  background:
    linear-gradient(
      to bottom,
      #fdfdfd,
      #f5f5f5);
  border-bottom: 2px solid #e0e0e0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}
.own-nav.super-user-header .main-link {
  fill: #555969 !important;
}
.super-user-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
}
.super-user-toolbar .menu {
  display: flex;
  align-items: center;
  gap: 30px;
  font-size: 13px;
  font-family: "Campton-Bold";
  white-space: nowrap;
}
.super-user-toolbar .menu .toolbar {
  display: flex;
  gap: 20px;
}
.super-user-toolbar .menu .toolbar a {
  display: flex;
  align-items: center;
  color: #555969;
  text-decoration: none;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 5px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  position: relative;
}
.super-user-toolbar .menu .toolbar a .nav-icon {
  margin-right: 6px;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.super-user-toolbar .menu .toolbar a.active::after {
  width: 100%;
  left: 0;
  background-color: #6dcc09;
}
.super-user-toolbar .menu .toolbar a:hover {
  color: #6dcc09;
  background-color: rgba(109, 204, 9, 0.05);
  transform: translateY(-1px);
}
.super-user-toolbar .menu .toolbar a:hover::after {
  width: 100%;
  left: 0;
}
.super-user-toolbar .menu .toolbar a::after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 50%;
  background-color: #6dcc09;
  transition: all 0.3s ease;
}
.super-user-toolbar .menu .toolbar .reports-dropdown {
  position: relative;
  display: flex;
  align-items: stretch;
  height: 60px;
}
.super-user-toolbar .menu .toolbar .reports-dropdown .reports-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 240px;
  background: white;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 8px 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.super-user-toolbar .menu .toolbar .reports-dropdown .reports-menu a {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 20px;
  margin: 0;
  border-radius: 0;
  font-size: 13px;
  color: #555969;
  text-transform: none;
  letter-spacing: 0.5px;
  justify-content: flex-start;
}
.super-user-toolbar .menu .toolbar .reports-dropdown .reports-menu a::after {
  display: none !important;
}
.super-user-toolbar .menu .toolbar .reports-dropdown .reports-menu a:hover {
  background-color: #f5f5f5;
  color: #6dcc09;
  transform: none;
}
.super-user-toolbar .menu .toolbar .reports-dropdown .reports-menu a.active {
  color: #6dcc09;
  font-family: "Campton-Bold";
  background-color: #f9f9f9;
}
/*# sourceMappingURL=header.component.css.map */
